import Overview from '@/rebuild/materials/shared/performance_report/FlowOverview.vue';
import MobOverview from '@/rebuild/materials/shared/performance_report/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/performance_report/mobile/MobFull.vue';
import FullIndex from '@/rebuild/materials/shared/performance_report/FullIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/performance_report/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext),
	'full': withProvider(FullIndex, useSelfContext)
};
